import styled from 'styled-components';
import AlertIcon from '@public/icon-alert.svg';
import { Typography } from '@components/common/Typography';
import Link from '@components/common/Link';
import CloseIcon from '@public/icon-close.svg';

export const Container = styled.div`
  margin-top: 2rem;
  width: 100%;
  max-width: 516px;
  max-height: 100%;
  border: 2px solid ${({ theme }) => theme.colors.secondary.red};
  border-radius: ${({ theme }) => theme.borderRadius.main};
  background: ${({ theme }) => theme.colors.secondary.paleRed};
  padding: 24px;
  box-sizing: border-box;
  margin-bottom: 32px;
  display: flex;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    margin: auto;
  }
`;

export const StyledAlertIcon = styled(AlertIcon)`
  width: 24px;
  height: 24px;
  path {
    fill: ${({ theme }) => theme.colors.secondary.red};
  }
`;

export const IconAndTitleContainer = styled.div`
  display: flex;
  width: calc(100% - 24px);
`;

export const TitleAndMessageContainer = styled.div`
  width: calc(100% - 24px);
  padding: 0 1rem;
  word-wrap: break-word;
`;

export const ErrorTitle = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.archivo};
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.secondary.red};
`;

export const ErrorMessage = styled(ErrorTitle)`
  display: block;
  font-weight: 400;
  margin-bottom: 0px;
  line-height: 24px;
`;

export const ErrorMessageLink = styled(Link)`
  font-family: ${({ theme }) => theme.fonts.archivo};
  font-size: 16px;
  font-weight: 400;
  line-height: 21px;
  color: ${({ theme }) => theme.colors.secondary.red};
  text-decoration: underline;

  :hover {
    opacity: 0.7;
    color: ${({ theme }) => theme.colors.secondary.red};
  }
`;

export const CloseIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  cursor: pointer;
  :hover {
    opacity: 0.7;
  }
`;

export const StyledCloseIcon = styled(CloseIcon)`
  width: 16px;
  height: 16px;
  path {
    fill: ${({ theme }) => theme.colors.secondary.red};
  }
`;
